import { TundishHeatMetricsPage } from "./TundishHeatMetricsPage";
import { TundishHMProvider } from "./context/TundishHeatMetricContext";

const TundishHeatMetrics = () => {
	return (
		<TundishHMProvider>
			<TundishHeatMetricsPage />
		</TundishHMProvider>
	);
};

export default TundishHeatMetrics;
